<template>
    <div
        class="useful-links"
        :class="{ 'with-bg': blok.sectionBackground.color }"
        :style="{ backgroundColor: blok.sectionBackground.color }"
    >
        <div class="container sm:container md:container lg:container xl:container mx-auto px-4">
            <h2 class="title">{{ blok.title }}</h2>
            <rich-text
                v-if="blok?.subtitle?.content?.[0]?.content"
                class="useful-links__text"
                :content="blok.subtitle"
            />
            <div class="links-row">
                <UiLinkText v-for="link in blok.links" :key="link._uid" :blok="link"></UiLinkText>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import type { IUsefulLinksConfig } from '@nuxt-monorepo/ui/types';

defineProps<{ blok: IUsefulLinksConfig }>();

const { render } = useStoryblokRichText({});
const richText = (content: any) => {
    return render(content.content);
};
</script>

<style lang="postcss" scoped></style>
